export const cardsData = [
  { id: '2_Hearts', suit: 'Hearts', value: '2', exercise: 'Push-ups', label: '2♥' },
  { id: '3_Hearts', suit: 'Hearts', value: '3', exercise: 'Push-ups', label: '3♥' },
  { id: '4_Hearts', suit: 'Hearts', value: '4', exercise: 'Push-ups', label: '4♥' },
  { id: '5_Hearts', suit: 'Hearts', value: '5', exercise: 'Push-ups', label: '5♥' },
  { id: '6_Hearts', suit: 'Hearts', value: '6', exercise: 'Push-ups', label: '6♥' },
  { id: '7_Hearts', suit: 'Hearts', value: '7', exercise: 'Push-ups', label: '7♥' },
  { id: '8_Hearts', suit: 'Hearts', value: '8', exercise: 'Push-ups', label: '8♥' },
  { id: '9_Hearts', suit: 'Hearts', value: '9', exercise: 'Push-ups', label: '9♥' },
  { id: '10_Hearts', suit: 'Hearts', value: '10', exercise: 'Push-ups', label: '10♥' },
  { id: 'J_Hearts', suit: 'Hearts', value: '11', exercise: 'Push-ups', label: 'J♥' },
  { id: 'Q_Hearts', suit: 'Hearts', value: '12', exercise: 'Push-ups', label: 'Q♥' },
  { id: 'K_Hearts', suit: 'Hearts', value: '13', exercise: 'Push-ups', label: 'K♥' },
  { id: 'A_Hearts', suit: 'Hearts', value: '14', exercise: 'Push-ups', label: 'A♥' },
  { id: '2_Diamonds', suit: 'Diamonds', value: '2', exercise: 'Sit-Ups', label: '2♦' },
  { id: '3_Diamonds', suit: 'Diamonds', value: '3', exercise: 'Sit-Ups', label: '3♦' },
  { id: '4_Diamonds', suit: 'Diamonds', value: '4', exercise: 'Sit-Ups', label: '4♦' },
  { id: '5_Diamonds', suit: 'Diamonds', value: '5', exercise: 'Sit-Ups', label: '5♦' },
  { id: '6_Diamonds', suit: 'Diamonds', value: '6', exercise: 'Sit-Ups', label: '6♦' },
  { id: '7_Diamonds', suit: 'Diamonds', value: '7', exercise: 'Sit-Ups', label: '7♦' },
  { id: '8_Diamonds', suit: 'Diamonds', value: '8', exercise: 'Sit-Ups', label: '8♦' },
  { id: '9_Diamonds', suit: 'Diamonds', value: '9', exercise: 'Sit-Ups', label: '9♦' },
  { id: '10_Diamonds', suit: 'Diamonds', value: '10', exercise: 'Sit-Ups', label: '10♦' },
  { id: 'J_Diamonds', suit: 'Diamonds', value: '11', exercise: 'Sit-Ups', label: 'J♦' },
  { id: 'Q_Diamonds', suit: 'Diamonds', value: '12', exercise: 'Sit-Ups', label: 'Q♦' },
  { id: 'K_Diamonds', suit: 'Diamonds', value: '13', exercise: 'Sit-Ups', label: 'K♦' },
  { id: 'A_Diamonds', suit: 'Diamonds', value: '14', exercise: 'Sit-Ups', label: 'A♦' },
  { id: '2_Clubs', suit: 'Clubs', value: '2', exercise: 'Squats', label: '2♣' },
  { id: '3_Clubs', suit: 'Clubs', value: '3', exercise: 'Squats', label: '3♣' },
  { id: '4_Clubs', suit: 'Clubs', value: '4', exercise: 'Squats', label: '4♣' },
  { id: '5_Clubs', suit: 'Clubs', value: '5', exercise: 'Squats', label: '5♣' },
  { id: '6_Clubs', suit: 'Clubs', value: '6', exercise: 'Squats', label: '6♣' },
  { id: '7_Clubs', suit: 'Clubs', value: '7', exercise: 'Squats', label: '7♣' },
  { id: '8_Clubs', suit: 'Clubs', value: '8', exercise: 'Squats', label: '8♣' },
  { id: '9_Clubs', suit: 'Clubs', value: '9', exercise: 'Squats', label: '9♣' },
  { id: '10_Clubs', suit: 'Clubs', value: '10', exercise: 'Squats', label: '10♣' },
  { id: 'J_Clubs', suit: 'Clubs', value: '11', exercise: 'Squats', label: 'J♣' },
  { id: 'Q_Clubs', suit: 'Clubs', value: '12', exercise: 'Squats', label: 'Q♣' },
  { id: 'K_Clubs', suit: 'Clubs', value: '13', exercise: 'Squats', label: 'K♣' },
  { id: 'A_Clubs', suit: 'Clubs', value: '14', exercise: 'Squats', label: 'A♣' },
  { id: '2_Spades', suit: 'Spades', value: '2', exercise: 'Burpees', label: '2♠' },
  { id: '3_Spades', suit: 'Spades', value: '3', exercise: 'Burpees', label: '3♠' },
  { id: '4_Spades', suit: 'Spades', value: '4', exercise: 'Burpees', label: '4♠' },
  { id: '5_Spades', suit: 'Spades', value: '5', exercise: 'Burpees', label: '5♠' },
  { id: '6_Spades', suit: 'Spades', value: '6', exercise: 'Burpees', label: '6♠' },
  { id: '7_Spades', suit: 'Spades', value: '7', exercise: 'Burpees', label: '7♠' },
  { id: '8_Spades', suit: 'Spades', value: '8', exercise: 'Burpees', label: '8♠' },
  { id: '9_Spades', suit: 'Spades', value: '9', exercise: 'Burpees', label: '9♠' },
  { id: '10_Spades', suit: 'Spades', value: '10', exercise: 'Burpees', label: '10♠' },
  { id: 'J_Spades', suit: 'Spades', value: '11', exercise: 'Burpees', label: 'J♠' },
  { id: 'Q_Spades', suit: 'Spades', value: '12', exercise: 'Burpees', label: 'Q♠' },
  { id: 'K_Spades', suit: 'Spades', value: '13', exercise: 'Burpees', label: 'K♠' },
  { id: 'A_Spades', suit: 'Spades', value: '14', exercise: 'Burpees', label: 'A♠' },
  {
    id: 'joker-1',
    value: 'JOKER',
    suit: 'Joker',
    exercise: 'Do 50 reps of the last exercise you did',
    image: 'joker-card.png'
  },
  {
    id: 'joker-2',
    value: 'JOKER',
    suit: 'Joker',
    exercise: 'Do 50 reps of the last exercise you did',
    image: 'joker-card.png'
  }
  ];